
const knisaMainTH = {
  "knisa_main_title": "เอกสารเข้า",
  "knisa_main_search_placeholder": "ค้นหาเอกสาร",
  "knisa_main_button_new": "เพิ่มเข้า",
}

const knisaCreatePageTH = {
  "knisa_create_page_title": "เข้าใหม่",
  "knisa_create_page_title_ids": "เข้า: {{id}}",
  "knisa_create_page_search_placeholder": "ค้นหา",
  "knisa_create_page_back": "กลับ",
  "knisa_create_page_addItem": "เพิ่มรายการ",
  "knisa_create_page_editTitle_aria": "แก้ไขหัวข้อเข้า",
  "knisa_create_divide_modal_title": "แบ่งเข้า {{entry}}-{{detail}}",
  "knisa_create_pallets_modal_title": "พาเลท — เข้า {{entry}}-{{detail}}",
}

const knisaCreateTitleModalTH = {
  "knisa_create_modal_title_title": "เข้าใหม่",
  "knisa_create_modal_title_date": "วันที่",
  "knisa_create_modal_title_time": "เวลา",
  "knisa_create_modal_title_grower": "เกษตรกร",
  "knisa_create_modal_title_refference": "อ้างอิง",
  "knisa_create_modal_title_carNum": "หมายเลขรถ",
  "knisa_create_modal_title_carSelect": "เลือกรถ",
  "knisa_create_modal_title_carClear": "ไม่มีรถ",
  "knisa_create_modal_title_driver": "คนขับ",
  "knisa_create_modal_title_warehouse": "คลังสินค้า",
  "knisa_create_modal_title_teudaType": "ประเภทเอกสาร",
  "knisa_create_modal_title_remark": "หมายเหตุ",
  "knisa_create_modal_title_saveTitle": "สร้างเข้า",
  "knisa_create_modal_title_continue": "ดำเนินการต่อ",
  "knisa_create_modal_title_referenceExistsForDate": "มีการอ้างอิงสำหรับวันที่ {{date}} แล้ว",
}

const knisaCreateProductModalTH = {
  "knisa_create_modal_product_title_create": "เพิ่มรายการเข้า",
  "knisa_create_modal_product_title_edit": "แก้ไขรายการ",
  "knisa_create_modal_product_externalEntry": "หมายเลขเข้าภายนอก",
  "knisa_create_modal_product_externalPalletExists": "หมายเลขนี้มีอยู่แล้ว",
  "knisa_create_modal_product_pallet": "พาเลท",
  "knisa_create_modal_product_qty": "จำนวน",
  "knisa_create_modal_product_product": "สินค้า",
  "knisa_create_modal_product_size": "ขนาด",
  "knisa_create_modal_product_package": "บรรจุภัณฑ์",
  "knisa_create_modal_product_weight": "น้ำหนัก",
  "knisa_create_modal_product_price": "ราคา",
  "knisa_create_modal_product_detection": "ตำแหน่ง",
  "knisa_create_modal_product_expiryDate": "วันหมดอายุ",
  "knisa_create_modal_product_copy": "คัดลอก",
  "knisa_create_modal_product_multiplier": "ตัวคูณ",

  "knisa_create_modal_product_includeWeight": "รวมน้ำหนัก",
  "knisa_create_modal_product_createButton": "เพิ่มรายการ",
  "knisa_create_modal_product_createPallet": "สร้างพาเลท",
  "knisa_create_modal_product_readScale_aria": "อ่านน้ำหนักจากเครื่องชั่ง",
}

const knisaCreateElementTH = {
  "knisa_create_element_swipe_edit": "แก้ไข",
  "knisa_create_element_swipe_delete": "ลบ",
  "knisa_create_element_swipe_divide": "แบ่ง",
  "knisa_create_element_netto": "สุทธิ",
  "knisa_create_element_brutto": "รวม",
  "knisa_create_element_print_aria": "พิมพ์",
}

const knisaNotificationsTH = {
  "knisa_notification_printPalletSuccess": "พิมพ์พาเลทหมายเลข {{num}} สำเร็จ",
  "knisa_notification_printEntrySuccess": "พิมพ์เข้าหมายเลข {{num}} สำเร็จ",
  "knisa_create_mass_print_title": "พิมพ์สติกเกอร์",
  "knisa_create_mass_print_message": "คุณแน่ใจหรือไม่ว่าต้องการพิมพ์สติกเกอร์ทั้งหมดพร้อมกัน?",
  "knisa_create_mass_print_confirm": "พิมพ์",
  "knisa_create_mass_print_printing": "กำลังพิมพ์...",
  "knisa_notification_massPrintSuccess": "พิมพ์สติกเกอร์ทั้งหมดสำเร็จแล้ว",
  "knisa_notification_growerHasNoProduct": "ซัพพลายเออร์รายนี้ไม่มีสินค้าที่เลือก",
  "knisa_notification_massPrintFailure": "สติกเกอร์อย่างน้อยหนึ่งรายการพิมพ์ไม่สำเร็จ - กรุณาลองอีกครั้ง",
  "knisa_notification_printEntryFailure": "พิมพ์เข้าหมายเลข {{num}} ไม่สำเร็จ",
  "knisa_notification_genericError": "มีบางอย่างผิดพลาด",
  "knisa_notification_entryUpdated": "อัปเดตเข้าสำเร็จ",
  "knisa_notification_referenceExists": "อ้างอิงถูกบันทึกแล้วเมื่อ {{date}}",
  "knisa_notification_cannotDeletePicked": "ไม่สามารถลบเข้าที่ถูกเบิกแล้วได้",
  "knisa_notification_palletDeleted": "ลบพาเลทสำเร็จ",
  "knisa_notification_entryDeleted": "ลบเข้าสำเร็จ",
  "knisa_notification_cannotDivide": "ไม่สามารถแบ่งได้",
}

export const knisaTranslationTH = {
  knisa: {
    ...knisaMainTH,
    ...knisaCreatePageTH,
    ...knisaCreateTitleModalTH,
    ...knisaCreateProductModalTH,
    ...knisaCreateElementTH,
    ...knisaNotificationsTH
  }
}
